import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import * as styles from './CollapsibleSection.css';

type CollapsibleSectionProps = {
  title: string;
  isOpen: boolean;
  onOpenChange: (next: boolean) => void;
  children: ReactNode;
};

export const CollapsibleSection = ({
  title,
  isOpen,
  onOpenChange,
  children,
}: CollapsibleSectionProps) => (
  <div className={styles.wrapper}>
    <button
      type="button"
      className={styles.header}
      onClick={() => onOpenChange(!isOpen)}
      aria-expanded={isOpen}
    >
      <span>{title}</span>
      <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
    </button>
    <div className={styles.body} hidden={!isOpen}>
      {children}
    </div>
  </div>
);
